import React, { forwardRef, useState, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line no-empty-pattern
const UploadLink = forwardRef(({ ..._props }, ref) => {
  const { t } = useTranslation('common');
  const [error, setError] = useState({
    linkUrl: '',
    linkName: '',
  });

  const [supportingDocuments, setSupportingDocuments] = useState({
    linkUrl: '',
    linkName: '',
  });

  const validURL = (str) => {
    if (!str || typeof str !== 'string') {
      return false;
    }

    const trimmedStr = str.trim();
    if (!trimmedStr.length) {
      return false;
    }

    // Must start with http:// or https://
    if (!/^https?:\/\//i.test(trimmedStr)) {
      return false;
    }

    try {
      const url = new URL(trimmedStr);
      // Basic validation: must have a valid hostname
      return url.hostname.length > 0;
    } catch (e) {
      return false;
    }
  };

  const validateForm = () => {
    let formIsValid = true;
    const errors = { linkUrl: '', linkName: '' };

    const trimmedUrl = supportingDocuments.linkUrl?.trim() || '';

    if (!trimmedUrl.length) {
      formIsValid = false;
      errors.linkUrl = t('UPLOAD_LINK.ENTER_LINK_URL');
    } else if (!validURL(trimmedUrl)) {
      formIsValid = false;
      errors.linkUrl = t('UPLOAD_LINK.ENTER_VALID_LINK_URL');
    }

    if (!supportingDocuments.linkName.replace(/\s/g, '').length) {
      formIsValid = false;
      errors.linkName = t('UPLOAD_LINK.ENTER_LINK_TITLE');
    }

    setError((state) => ({
      ...state,
      ...errors,
    }));
    return formIsValid;
  };

  useImperativeHandle(ref, () => ({
    selectedDocument() {
      if (validateForm()) {
        return supportingDocuments;
      }
      return false;
    },
  }));

  const handleChange = (event) => {
    const fieldName = event.currentTarget.name;
    const fieldValue = event.currentTarget.value;

    setSupportingDocuments({
      ...supportingDocuments,
      [fieldName]: fieldValue,
    });

    // Clear error for the field being edited
    if (error[fieldName]) {
      setError((prevError) => ({
        ...prevError,
        [fieldName]: '',
      }));
    }
  };

  return (
    <form noValidate>
      <div className="input-group link-input pt-0 form-floating-label position-relative fixed-label">
        <label htmlFor="linkUrl" className={`custom-placeholder ${supportingDocuments.linkUrl ? 'hidden' : ''}`}>
          {t('UPLOAD_LINK.LINK_URL_PLACEHOLDER')} <span className="red-asterisk">*</span>
        </label>
        <input
          type="text"
          id="linkUrl"
          name="linkUrl"
          value={supportingDocuments.linkUrl}
          onChange={handleChange}
          placeholder=""
          className="input-doc-type form-control text-bordered"
        />
      </div>
      {error.linkUrl && <span className="error-message">{error.linkUrl}</span>}

      <div className="input-group link-input pt-0 form-floating-label position-relative fixed-label">
        <label htmlFor="linkUrl" className={`custom-placeholder ${supportingDocuments.linkName ? 'hidden' : ''}`}>
          {t('UPLOAD_LINK.LINK_TITLE_LABEL')} <span className="red-asterisk">*</span>
        </label>
        <input
          type="text"
          name="linkName"
          value={supportingDocuments.linkName}
          onChange={handleChange}
          placeholder=""
          className="input-doc-type form-control text-bordered"
        />
      </div>
      {error.linkName && <span className="error-message">{error.linkName}</span>}
    </form>
  );
});

UploadLink.displayName = 'UploadLink';

export default UploadLink;
